import React, { useEffect, useState } from 'react'
import { CardBody, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { NineDay, Save, SixDay, ThreeDay, } from '../../../Constant';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getRewardRate, getRewardRateRole, postRewardRate, postRewardRateRole } from '../../../CommonUrl';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Btn } from '../../../AbstractElements';

const AgentForm = ({ userValue, handleModal }) => {
    console.log('user', userValue)
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getDeliveryData();
    }, []);

    const getDeliveryData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRewardRate : getRewardRateRole);
        if (data.status === true) {
            const customerAppArray = data?.data;
            customerAppArray.map((e) => {
                if (e.type === 'collection_agent' && e.agent_id === userValue) {
                    setValue('customerThree', e?.thirty);
                    setValue('customerSix', e?.sixty);
                    setValue('customerNine', e?.ninety);
                    setValue('agentThree', e?.agent_thirty);
                    setValue('agentSix', e?.agent_sixty);
                    setValue('agentNine', e?.agent_ninety);
                }
            })
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }


    const onSubmit = async (data) => {
        setLoading(true);
        const customerApp = [
            {
                type: 'collection_agent',
                thirty: data?.customerThree,
                sixty: data?.customerSix,
                ninety: data?.customerNine,
                agent_thirty: data?.agentThree,
                agent_sixty: data?.agentSix,
                agent_ninety: data?.agentNine,
                agent_id: userValue
            }
        ];
        const postRequest = {
            reward_percentage: customerApp,
        }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? postRewardRate : postRewardRateRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                handleModal();
                toast.success(addAreaResponse.data.message);
            } else {
                toast.error(addAreaResponse.data.message)
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <CardBody>
            <h4>Agent Reward Ratio</h4>
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Row className="g-3 pt-1">
                    <Col md='6'>
                        <Label className="form-label" for="agentThree">{ThreeDay}</Label>
                        <input className="form-control" id="agentThree" type="text"
                            {...register('agentThree')}
                        />
                    </Col>
                    <Col md='6'>
                        <Label className="form-label" for="agentSix">{SixDay}</Label>
                        <input className="form-control" id="agentSix" type="text"
                            {...register('agentSix')}
                        />
                    </Col>
                </Row>
                <Row className="g-3 pt-3">
                    <Col md='6'>
                        <Label className="form-label" for="agentNine">{NineDay}</Label>
                        <input className="form-control" id="agentNine" type="number" min="0"
                            {...register('agentNine')}
                        />
                    </Col>
                </Row>
                <h4 className='pt-2'>Customer Reward Ratio</h4>
                <Row className="g-3 pt-1">
                    <Col md='6'>
                        <Label className="form-label" for="agentThree">{ThreeDay}</Label>
                        <input className="form-control" id="agentThree" type="text"
                            {...register('customerThree')}
                        />
                    </Col>
                    <Col md='6'>
                        <Label className="form-label" for="agentSix">{SixDay}</Label>
                        <input className="form-control" id="agentSix" type="text"
                            {...register('customerSix')}
                        />
                    </Col>
                </Row>
                <Row className="g-3 pt-3">
                    <Col md='6'>
                        <Label className="form-label" for="agentNine">{NineDay}</Label>
                        <input className="form-control" id="agentNine" type="number" min="0"
                            {...register('customerNine')}
                        />
                    </Col>
                </Row>
                <FormGroup>
                </FormGroup>
                <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
            </Form>
        </CardBody>

    )
}

export default AgentForm
